export default __webpack_public_path__ + "static/genopets-2-g-46df70979ae6fc66265214680ef80ce7.webp";